import { render } from "./TheBenXe.vue?vue&type=template&id=77705538"
import script from "./TheBenXe.vue?vue&type=script&lang=js"
export * from "./TheBenXe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__